<div class="login-wrapper">
    <mat-card class="login-card">
        <div class="logo-area">
            <mat-icon class="app-logo">search</mat-icon>
            <h1>Usonar Dev</h1>
        </div>

        <form [formGroup]="loginForm" (ngSubmit)="onSubmit()">

            <mat-form-field appearance="outline" class="full-width">
                <mat-label>Email</mat-label>
                <input matInput formControlName="username" required>
                <mat-error *ngIf="loginForm.get('username')?.invalid">Email is required</mat-error>
            </mat-form-field>

            <mat-form-field appearance="outline" class="full-width">
                <mat-label>Password</mat-label>
                <input matInput [type]="hide ? 'password' : 'text'" formControlName="password" required>
                <button mat-icon-button matSuffix (click)="hide = !hide" type="button">
                    <mat-icon>{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
                </button>
                <mat-error *ngIf="loginForm.get('password')?.invalid">Password is required</mat-error>
            </mat-form-field>

            <div class="error-message" *ngIf="errorMessage">
                <mat-icon>error_outline</mat-icon>
                <span>{{ errorMessage }}</span>
            </div>

            <div class="actions">
                <a href="#" (click)="$event.preventDefault(); openForgotPasswordDialog()" class="forgot-link">
                    Forgot password?
                </a>

                <button mat-flat-button color="primary" class="submit-btn" [disabled]="loginForm.invalid">
                    Next
                </button>
            </div>

        </form>
    </mat-card>
</div>